import { request } from "../api/client";

export function requestPasswordRecovery(email: string): Promise<{ message: string }> {
  return request<{ message: string }>(
    "/api/v1/auth/password-recovery",
    {
      method: "POST",
      body: JSON.stringify({ email })
    },
    null
  );
}

export function resetRecoveredPassword(
  token: string,
  newPassword: string
): Promise<null> {
  return request<null>(
    "/api/v1/auth/password-recovery/reset",
    {
      method: "POST",
      body: JSON.stringify({ token, newPassword })
    },
    null
  );
}
